import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { editIcon } from '../../../config/variables';
import { getMedia, hasPermission, navigateRoute } from '../../../utils/HelperFunctions';
import { IBodyType } from '../types/interfaces';
import { ITableContainerProps } from '../../../types/Interfaces';
import DeleteButton from '../../../components/buttons/DeleteButton';

const BodyTypesTableContainer = ({ tableHeaders, data, noDataMessage, lessColumns }: ITableContainerProps<IBodyType[]>) => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

  const hasEditPermission = hasPermission(['body_types.edit'])

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
      <div className="table_header">
        {tableHeaders?.map((header, index) =>
          !header ? null : (
            <span className={`head ${header.customClass}`} key={index}>
              {header.label}
            </span>
          )
        )}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
        {data?.length > 0 ? (
          <>
            {data?.map((item, index) => (
              <div
                className={`item ${hasEditPermission && 'clickable'} has_big_logo body_types`}
                key={index}
                onClick={(e) => {
                  hasEditPermission && navigateRoute(e, `/body-types/create-body-type/${item.id}`, navigate);
                }}
              >
                <div className="column">
                  <div className="large-icon-container">{getMedia(item?.media, 'icon') ? <img src={getMedia(item?.media, 'icon')?.url} alt="" /> : '-'}</div>
                </div>
                <div className="column">
                  <div className="capitalize">{item?.description?.en || '-'}</div>
                </div>
                <div className="column">{item?.description?.ar || '-'}</div>
                {hasEditPermission && (
                  <div className="column actions actions_col">
                    <div
                      className="action_btn edit"
                      onClick={(e) => {
                        navigateRoute(e, `/body-types/create-body-type/${item.id}`, navigate);
                      }}
                    >
                      {editIcon}
                    </div>
                    <DeleteButton deleteRoute={`/admin/body-types`} queryKey="body-types" id={item.id} />
                  </div>
                )}
              </div>
            ))}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
      {/* {deleteModalOpen && (
                <ModalContainer small>
                    <DeleteModal id={deleteModalOpen} setModal={setDeleteModalOpen} setRefetchData={setRefetchData} route={"/service-providers"} successMsg={t("deletedServiceProvider")} warningMsg={t("deleteConfirmationMessageServiceProvider")} />
                </ModalContainer>
            )} */}
    </div>
  );
};

export default BodyTypesTableContainer;
